/*
 * global-scroll-lock-fix.js  (v2 — mobile menu safe)
 *
 * Clears a stuck scroll lock (js-drawer-open* classes / inline overflow)
 * left behind by third-party overlays such as Shiprocket Smart Cart.
 *
 * v2 fixes:
 *  - The theme's mobile menu (#NavDrawer) is opened ONLY by adding
 *    `js-drawer-open js-drawer-open-left` to <body>. It never sets
 *    aria-hidden="false", so v1 thought "lock present, nothing open" and
 *    removed the classes within ~600ms, snapping the menu shut. The theme's
 *    MobileMenu still believed it was open, so the next tap did nothing.
 *    We now never touch the lock while the left drawer class is present.
 *  - v1 used `offsetParent !== null` as a visibility test. That is always
 *    null for position:fixed elements (every drawer/overlay), so real open
 *    drawers were never detected. Replaced with a computed-style + on-screen
 *    rectangle check.
 *  - The lock must look stuck on two consecutive checks before it is cleared,
 *    so open/close animations are never interrupted.
 */
(function () {
  'use strict';

  if (window.__globalScrollLockFixInstalled) return;
  window.__globalScrollLockFixInstalled = true;

  var CONFIG = {
    LOCK_CLASSES: ['js-drawer-open', 'js-drawer-open-left', 'js-drawer-open-right'],
    // Classes owned by the theme's own drawers: while present, leave the lock alone.
    THEME_OWNED_CLASSES: ['js-drawer-open-left'],
    CHECK_INTERVAL_MS: 700,

    VISIBLE_DRAWER_SELECTORS: [
      'cart-drawer[aria-hidden="false"]',
      '#NavDrawer:not([inert])',
      '.global-drawer.global-drawer--is-visible',
      '[id*="shiprocket" i]',
      '[class*="shiprocket" i]',
      '[class*="smart-cart" i]',
      '[class*="sr-headless" i]',
      '[class*="cart-drawer" i]',
      '.drawer[aria-hidden="false"]',
      '.popup.visible',
      '.verification-popup-container[style*="block"]'
    ].join(','),

    DEBUG: false
  };

  function log() {
    if (CONFIG.DEBUG) console.log.apply(console, ['[scroll-lock-fix]'].concat([].slice.call(arguments)));
  }

  function hasAnyClass(el, list) {
    return list.some(function (c) { return el.classList.contains(c); });
  }

  function isLocked() {
    return hasAnyClass(document.documentElement, CONFIG.LOCK_CLASSES) ||
           hasAnyClass(document.body, CONFIG.LOCK_CLASSES);
  }

  function themeDrawerOwnsLock() {
    return hasAnyClass(document.body, CONFIG.THEME_OWNED_CLASSES) ||
           hasAnyClass(document.documentElement, CONFIG.THEME_OWNED_CLASSES);
  }

  // Works for position:fixed elements (unlike offsetParent).
  function isOnScreen(el) {
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    var r = el.getBoundingClientRect();
    if (r.width === 0 || r.height === 0) return false;
    return r.right > 0 && r.bottom > 0 && r.left < window.innerWidth && r.top < window.innerHeight;
  }

  function anyDrawerVisible() {
    var nodes;
    try {
      nodes = document.querySelectorAll(CONFIG.VISIBLE_DRAWER_SELECTORS);
    } catch (e) {
      return true; // if unsure, do nothing
    }
    for (var i = 0; i < nodes.length; i++) {
      if (isOnScreen(nodes[i])) return true;
    }
    return false;
  }

  function clearLock() {
    var restoreY = 0;
    if (document.body.style.position === 'fixed' && document.body.style.top) {
      restoreY = -parseInt(document.body.style.top, 10) || 0;
    }

    CONFIG.LOCK_CLASSES.forEach(function (c) {
      document.documentElement.classList.remove(c);
      document.body.classList.remove(c);
    });

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.height = '';

    if (restoreY) window.scrollTo(0, restoreY);
    log('cleared a stuck scroll lock');
  }

  var suspectCount = 0;
  setInterval(function () {
    if (isLocked() && !themeDrawerOwnsLock() && !anyDrawerVisible()) {
      suspectCount++;
      if (suspectCount >= 2) {
        clearLock();
        suspectCount = 0;
      }
    } else {
      suspectCount = 0;
    }
  }, CONFIG.CHECK_INTERVAL_MS);

  log('installed (v2)');
})();